import { Product, ValidationError } from './types'

export function getProductName(product: Product) {
  return [product.quantity || '', product.name].join(' ').trim()
}

export function getDeliveryErrors(products: Product[]) {
  const errors: { [key: string]: ValidationError[] } = {}

  products.forEach((product) => {
    errors[product.id] = []

    const minQuantity = product.quantity || 1

    if (product.assetDeliveryType === 'PhotoAsset') {
      const assets = product.assetDeliveries
      const groupMasterAssets = assets.filter((a) => a.masterForGroupId)
      const primaryAssets = assets.filter((a) => a.isPrimary)
      const requiredPrimaryAssets = Math.min(
        groupMasterAssets.length,
        minQuantity
      )

      if (assets.length === 0) {
        errors[product.id].push({
          name: 'EMPTY',
          message: 'Mangler bilder',
        })
      }

      if (!assets.every((a) => a.image.url)) {
        errors[product.id].push({
          name: 'PENDING',
          message: 'Alle bilder må være lagret',
        })
      }

      if (!groupMasterAssets.every((a) => a.labels && a.labels.length > 0)) {
        errors[product.id].push({
          name: 'UNLABELLED',
          message: 'Alle bilder må være navngitte',
        })
      }

      if (assets.length > 0 && groupMasterAssets.length < minQuantity) {
        errors[product.id].push({
          name: 'TOO_FEW_ASSETS',
          message: `Kommenter hvorfor du leverer et lavere antall bilder (${groupMasterAssets.length} av ${minQuantity})`,
          resolveWithComment: true,
        })
      }

      if (primaryAssets.length < requiredPrimaryAssets) {
        errors[product.id].push({
          name: 'TOO_FEW_PRIMARIES',
          message: `${requiredPrimaryAssets} bilde${
            minQuantity > 1 ? 'r' : ''
          } skal helst være stjernemerket. Du har stjernemerket ${
            primaryAssets.length
          }. Kommenter hvorfor under`,
          resolveWithComment: true,
        })
      } else if (primaryAssets.length > requiredPrimaryAssets) {
        errors[product.id].push({
          name: 'TOO_MANY_PRIMARIES',
          message: `Maks ${requiredPrimaryAssets} bilde${
            minQuantity > 1 ? 'r' : ''
          } skal være stjernemerket. Du har stjernemerket ${
            primaryAssets.length
          }`,
        })
      }
    }

    if (product.assetDeliveryType === 'UrlAsset') {
      const assets = product.assetDeliveries

      if (assets.length === 0) {
        errors[product.id].push({
          name: 'EMPTY',
          message: 'Mangler lenker',
        })
      }
    }
  })

  return errors
}
